module.exports = {
  title: '产品品牌管理',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'product-brand-list',
    },
  },
};
